var plugin_rtlignore_default = {
  "alignLeft": "-TLVS",
  "textWrapNowrap": "-Eiso",
  "alignRight": "QGeBQ",
  "alignCenter": "EcPFh",
  "sizeFullWidth": "lVE8R",
  "renderedInTable": "WNym5",
  "sizeOriginal": "Tye4A",
  "sizeContent": "oeZO-",
  "sizeSmall": "S0QfA",
  "sizeSmallCenter": "-ZSfG",
  "flex": "-sVXO",
  "atomic": "_8Mw30",
  "embed": "iy2yI",
  "horizontalScrollbar": "_75TbE",
  "pluginContainerMobile": "_2GR0d"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
